import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { IReleaseNote } from '@shared-models/release-note.model';
import { Observable } from 'rxjs';
import { IApiObject } from '@shared-libs/interfaces';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class BadgeProvider extends Provider<void> {
	protected readonly url: string = '/release-notes';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public getReleaseNotes(): Observable<number> {
		return this.api
			.get<IApiObject<IReleaseNote>>(`/users-seen-release-notes/latest`, true)
			.pipe(map((result: any) => (result.data.seen ? 0 : 1)));
	}
}
